module.exports = __webpack_public_path__ + "static/media/blog10-image.34337ce4.jpg";